const WORKSPACE_CLIENT_ID_KEY = "vizibly-workspace-client-id";

export function getWorkspaceClientIdFromStore():string|null {
    return localStorage.getItem(WORKSPACE_CLIENT_ID_KEY);
}

export function saveWorkspaceClientIdToStore(id: string):void {
    localStorage.setItem(WORKSPACE_CLIENT_ID_KEY, id);
}

export function removeWorkspaceClientIdFromStore():void {
    localStorage.removeItem(WORKSPACE_CLIENT_ID_KEY);
}
